export default {
    asset: ['other-asset', 'cash', 'bank', 'receivable', 'fixed-asset', 'payment-clearing', 'stock'],

    liability: [
        'account-payable',
        'credit-card',
        'other-current-liability',
        'short-term-commitment',
        'long-term-liability'
    ],

    equity: ['equity'],

    income: ['income', 'other-income'],

    expense: ['expense', 'cost-of-goods-sold', 'other-expense']
};
